/* global process  */

export const API_URL = process.env.API_URL;
export const AZURE_AD_CLIENT_ID = process.env.AZURE_AD_CLIENT_ID;
export const AZURE_AD_REDIRECT_URL = process.env.AZURE_AD_REDIRECT_URL;
